export default __webpack_public_path__ + "static/media/riseLogo.bdab43e6.png";